import { useState } from 'react';
import AdminLayout from '@/components/feature/AdminLayout';

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState({
    siteName: '绿证通',
    siteDescription: '绿色电力证书供需撮合平台',
    contactEmail: 'info@firmai.cn',
    contactPhone: '',
    maxListingDays: 90,
    autoOfflineEnabled: true,
    reviewRequired: true,
    dailyPublishLimit: 20,
  });

  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <AdminLayout>
      <div className="p-4 md:p-6 space-y-6 max-w-2xl">
        <div>
          <h2 className="text-lg font-semibold text-foreground-950">系统设置</h2>
          <p className="text-sm text-foreground-500 mt-0.5">平台基础配置</p>
        </div>

        {/* Basic settings */}
        <div className="bg-white rounded-xl border border-background-200 p-4 md:p-5 space-y-4">
          <h3 className="text-sm font-semibold text-foreground-950 border-b border-background-100 pb-3">基本信息</h3>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">平台名称</label>
            <input
              type="text"
              value={settings.siteName}
              onChange={(e) => setSettings({ ...settings, siteName: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-background-200 bg-white text-sm text-foreground-900 focus:outline-none focus:border-foreground-400"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">平台简介</label>
            <textarea
              value={settings.siteDescription}
              onChange={(e) => setSettings({ ...settings, siteDescription: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-background-200 bg-white text-sm text-foreground-900 focus:outline-none focus:border-foreground-400 h-20 resize-none"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-foreground-600 mb-1">联系邮箱</label>
              <input
                type="email"
                value={settings.contactEmail}
                onChange={(e) => setSettings({ ...settings, contactEmail: e.target.value })}
                className="w-full px-3 py-2 rounded-lg border border-background-200 bg-white text-sm text-foreground-900 focus:outline-none focus:border-foreground-400"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-600 mb-1">客服电话</label>
              <input
                type="text"
                value={settings.contactPhone}
                onChange={(e) => setSettings({ ...settings, contactPhone: e.target.value })}
                className="w-full px-3 py-2 rounded-lg border border-background-200 bg-white text-sm text-foreground-900 focus:outline-none focus:border-foreground-400"
              />
            </div>
          </div>
        </div>

        {/* Business rules */}
        <div className="bg-white rounded-xl border border-background-200 p-4 md:p-5 space-y-4">
          <h3 className="text-sm font-semibold text-foreground-950 border-b border-background-100 pb-3">业务规则</h3>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">
              挂牌有效期（天）：<span className="text-foreground-900 font-medium">{settings.maxListingDays}</span>
            </label>
            <input
              type="range"
              min={30}
              max={365}
              step={5}
              value={settings.maxListingDays}
              onChange={(e) => setSettings({ ...settings, maxListingDays: Number(e.target.value) })}
              className="w-full cursor-pointer"
            />
            <div className="flex justify-between text-xs text-foreground-400">
              <span>30天</span>
              <span>365天</span>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">
              每日发布上限：<span className="text-foreground-900 font-medium">{settings.dailyPublishLimit}</span> 条
            </label>
            <input
              type="range"
              min={5}
              max={100}
              step={5}
              value={settings.dailyPublishLimit}
              onChange={(e) => setSettings({ ...settings, dailyPublishLimit: Number(e.target.value) })}
              className="w-full cursor-pointer"
            />
            <div className="flex justify-between text-xs text-foreground-400">
              <span>5条</span>
              <span>100条</span>
            </div>
          </div>

          <div className="flex items-center justify-between py-2">
            <div>
              <span className="text-sm text-foreground-700">到期自动下架</span>
              <p className="text-xs text-foreground-400 mt-0.5">挂牌信息到期后自动设为下架状态</p>
            </div>
            <button
              onClick={() => setSettings({ ...settings, autoOfflineEnabled: !settings.autoOfflineEnabled })}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                settings.autoOfflineEnabled ? 'bg-green-500' : 'bg-background-300'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  settings.autoOfflineEnabled ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>

          <div className="flex items-center justify-between py-2">
            <div>
              <span className="text-sm text-foreground-700">挂牌需审核</span>
              <p className="text-xs text-foreground-400 mt-0.5">新发布的挂牌信息需要管理员审核后才能展示</p>
            </div>
            <button
              onClick={() => setSettings({ ...settings, reviewRequired: !settings.reviewRequired })}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                settings.reviewRequired ? 'bg-green-500' : 'bg-background-300'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  settings.reviewRequired ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>

        {/* Save button */}
        <div className="flex items-center gap-3">
          <button
            onClick={handleSave}
            className="px-6 py-2.5 rounded-lg text-sm font-medium bg-foreground-950 text-white hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            保存设置
          </button>
          {saved && (
            <span className="flex items-center gap-1.5 text-sm text-green-600">
              <i className="ri-check-line" />
              设置已保存
            </span>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
